import { createFileRoute, Outlet } from '@tanstack/react-router';

/** `/settings/*`: the settings page (`settings.index.tsx`) and Settings → Models (`settings.models.tsx`, 23). */
export const Route = createFileRoute('/_app/settings')({ component: Outlet });
